export const GET_LIST_CASE_AUTOMATION_ASYNC = 'GET_LIST_CASE_AUTOMATION_ASYNC'
export const GET_LIST_CASE_AUTOMATION_SUCCESS = 'GET_LIST_CASE_AUTOMATION_SUCCESS'
export const GET_LIST_CASE_AUTOMATION_FAIL = 'GET_LIST_CASE_AUTOMATION_FAIL'

export const GET_CASE_DETAIL_AUTOMATION_ASYNC = 'GET_CASE_DETAIL_AUTOMATION_ASYNC'

export const AFFIDAVIT_GENERATE_ASYNC = 'AFFIDAVIT_GENERATE_ASYNC'

export const SELECT_ATTACHMENT_ASYNC = 'SELECT_ATTACHMENT_ASYNC'
